import Swup from 'swup';
import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [
    // new SwupScriptsPlugin()
  ]
};

const swup = new Swup(options); 

// // Events
swup.on('contentReplaced', init);

// // Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  window.scrollTo(0,0)
  if(window.location.pathname == '/contact') {
    document.body.classList.add('black');
  } else {
    document.body.classList.remove('black');
  }

  if(window.location.pathname !== '/') {
    document.querySelector('.footer').classList.remove('out');
  } else {
    document.querySelector('.footer').classList.add('out');
  }
  // startSliders();
  // cookieNotice();
}

// // function startSliders() {
// //   if(document.querySelectorAll('.splide').length) { 
// //     let perPage = isMobile ? 1.5 : 3.5;
// //     let splide = new Splide( '.splide', {
// //       type: 'loop',
// //       focus  : 'left',
// //       perPage: perPage,
// //       arrows: true,
// //       pagination: false
// //     });

// //     splide.mount();
// //   }

// // }

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }